/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getStorageKey.ts
 */

import { EnhancedStorageOptions } from '../types/EnhancedStorageOptions'

import { getKeySeparator } from './getKeySeparator'

export const getStorageKey = (key: string, options: EnhancedStorageOptions) => {
  return `${options.name}${getKeySeparator(options)}${key}`
}
